import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Container, Row, Col } from 'react-grid-system';
import { showToast } from "../../store/actions/toastAction";
import { appendTest } from '../../store/actions/collectTestResults';
import { COLLECT_TESTS } from '../../store/actions/types';
import { GREY, RED, LIGHTBLUE, LIGHTGREY, MAROONHOVER } from "../../utils/color_utils";
import Test from "./Test";
// import AlarmIcon from '@material-ui/icons/MoneySharp';
import ShareIcon from "@material-ui/icons/StarSharp";
import Icon from 'supercons';

// const sendBtn = {
//   backgroundColor: LIGHTBLUE,
//   color: "#fff"
// };
// const sendBtn2 = {
//   backgroundColor: RED,
//   color: "#fff"
// };
const table = {
  color: "#515A5A",
  fontSize: 14,
  border: "1px solid #CAC9C8",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 7
}
const tableh = {
color: "#515A5A",
fontSize: 14,
border: "1px solid #707B7C",
backgroundColor: '#F2F3F4',
padding: 10,
borderRadius: 15
}
const tableM = {
color: "#515A5A",
fontSize: 18,
border: "1px solid #707B7C",
backgroundColor: '#F2F3F4',
padding: 1,
borderRadius: 15
}

const buttonStyle = {
  backgroundColor: RED,
  color: "#fff",
  width: "120px",
  height: "48px",
  border: "10px solid",
  borderColor: "#fff",
  borderRadius: "15px",
  textDecoration: "none"
};

const hoverbuttonStyle = {
  backgroundColor: MAROONHOVER,
  color: "#fff",
  width: "120px",
  height: "48px",
  border: "10px solid",
  borderColor: "#fff",
  borderRadius: "15px",
  textDecoration: "none"
};

const styles = {
mlist: {
  width: 250,
  // backgroundColor: 'red',
},
survs: {
  width: 1500,
  // backgroundColor: 'blue',
},
row2: {
//     backgroundColor: 'green',
},
col1: {
  backgroundColor: 'yellow',
},
col2: {
  backgroundColor: 'brown',
},
col: {
  padding: '1rem',
  backgroundColor: '#33b5e5',
  border: '2px solid #fff',
  color: '#fff',
  textAlign: 'center'
  }
};

function DoTest(props) {
  const [open, setOpen] = React.useState(false);
  const [showRetryExhaustedPopup, setShowRetryExhaustedPopup] = React.useState(false);
  const [exitGuardEnabled, setExitGuardEnabled] = React.useState(true);
  var showtheTest = props.size;
  // Developer auto-complete disabled
  const confirmExitMessage = 'Are you sure you want to exit the test? Your progress may be lost and it may count as an attempt.';
  
  const handleClickOpen = () => {
    // Allow owners to always open the test dialog
    const isOwner = props && props.userID && props.publisherid && (props.userID === props.publisherid);

    // Check if retries are exhausted for non-owners
    if (props.retriesExhausted && !isOwner) {
      setShowRetryExhaustedPopup(true);
      return;
    }
    setExitGuardEnabled(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogClose = (event, reason) => {
    // Intercept backdrop clicks and ESC key to confirm before closing
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      if (!exitGuardEnabled) {
        // If test already finished, just close without confirmation
        return handleClosex(
          props.thoughtID,
          props.userID,
          props.publisherid,
          props.real_companyID,
          props.companyID
        );
      }
      const ok = window.confirm(confirmExitMessage);
      if (!ok) return;
      return handleClosex(
        props.thoughtID,
        props.userID,
        props.publisherid,
        props.real_companyID,
        props.companyID
      );
    }
    handleClose();
  };

  const handleClosex = (thoughtID, userID, publisherID, real_companyID, companyID) => {
    //props.resetTest(thoughtID, userID, props.publisherid);
    props.resetTest(
      thoughtID, 
      userID, 
      publisherID,
      real_companyID, 
      companyID
      );
    props.getSurveyStage(thoughtID);
    try { if (typeof props.onAfterExit === 'function') props.onAfterExit(); } catch (e) {}
    setOpen(false);
  };

  // Warn when closing tab/window while test dialog is open
  React.useEffect(() => {
    if (!open || !exitGuardEnabled) return;
    const beforeUnloadHandler = (e) => {
      e.preventDefault();
      e.returnValue = confirmExitMessage;
      return confirmExitMessage;
    };
    window.addEventListener('beforeunload', beforeUnloadHandler);
    return () => {
      try { window.removeEventListener('beforeunload', beforeUnloadHandler); } catch (_) {}
    };
  }, [open, exitGuardEnabled]);

  return (
    <div>
      {/* <IconButton color="secondary" aria-label="add an alarm" onClick={handleClickOpen}>
        <div style={{ color: 'black', textShadow: '3px 3px 3px gold' }}>
          <Icon glyph="transactions" size={32} />
        </div>
      </IconButton> */}
        <div onClick={handleClickOpen}
          style={{ 
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: 'black', 
            textShadow: '3px 3px 3px gold'
            }}
            >
          <ShareIcon />
        </div>
        {/* Developer auto-complete removed */}
      {/* <Dialog open={open} onClose={handleClose()} aria-labelledby="form-dialog-title" */}
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        onClose={handleDialogClose}
        fullWidth
        maxWidth="sm"
        scroll="paper"
        style={{
          alignItems: 'flex-start'
        }}
        PaperProps={{
          style: {
            width: '100%',
            maxWidth: '600px',
            maxHeight: '90vh',
            margin: '1vh auto 0 auto', // push near top edge while centered horizontally
            alignSelf: 'flex-start' // override container's center alignment
          }
        }}
      >
        {/* Close button at top right corner */}
        <div style={{
          position: 'absolute',
          top: '10px',
          right: '15px',
          cursor: 'pointer',
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#666',
          zIndex: 1000,
          backgroundColor: 'white',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}
        onClick={() => {
          if (!exitGuardEnabled) {
            return handleClosex(
              props.thoughtID, 
              props.userID, 
              props.publisherid, 
              props.real_companyID, 
              props.companyID
            );
          }
          const ok = window.confirm(confirmExitMessage);
          if (!ok) return;
          handleClosex(
            props.thoughtID, 
            props.userID, 
            props.publisherid, 
            props.real_companyID, 
            props.companyID
          );
        }}
        onMouseOver={(e) => {
          e.target.style.color = '#000';
          e.target.style.backgroundColor = '#f0f0f0';
        }}
        onMouseOut={(e) => {
          e.target.style.color = '#666';
          e.target.style.backgroundColor = 'white';
        }}
        >
          ×
        </div>
        <DialogContent
          style={{
            maxHeight: 'calc(90vh - 80px)',
            overflowY: 'auto',
            padding: 0
          }}
        >
          <DialogContentText
               >
              <Test 
                thoughtID={props.thoughtID}
                companyID={props.companyID}
                real_companyID={props.real_companyID}
                userID={props.userID}
                surveyName={props.surveyName}
                size={props.size}
                showLeadb={props.showLeadb}
                handleClose={handleClose} 
                // thought={props.thought}
                //resetTest={props.resetTest}
                //getSurveyStage={props.getSurveyStage}
                publisherid={props.publisherid}
                thoughtType={props.thoughtType}
                title={props.title}
                subtitle={props.subtitle}
                onTestComplete={() => {
                  try { localStorage.setItem('TEST_TAKING_ACTIVE', '0'); } catch (_) {}
                  setExitGuardEnabled(false);
                }}
              />
          </DialogContentText>

        </DialogContent>
      </Dialog>

      {/* Retry Exhausted Popup */}
      <Dialog 
        open={showRetryExhaustedPopup} 
        onClose={() => setShowRetryExhaustedPopup(false)}
        aria-labelledby="retry-exhausted-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ textAlign: 'center', backgroundColor: '#fdf2f2', color: '#c53030' }}>
          🚫 No Retries Left!
        </DialogTitle>
        <DialogContent style={{ backgroundColor: '#fdf2f2', padding: '20px' }}>
          <DialogContentText style={{ textAlign: 'center', color: '#742a2a', fontSize: '14px' }}>
            You have exhausted all attempts for this test and can no longer take it.
            <br/><br/>
            The test is now permanently unavailable for you.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ backgroundColor: '#fdf2f2', justifyContent: 'center', paddingBottom: '20px' }}>
          <Button 
            onClick={() => setShowRetryExhaustedPopup(false)} 
            style={{
              backgroundColor: '#e53e3e',
              color: 'white',
              padding: '8px 20px',
              borderRadius: '5px'
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  appendTest: (params) => dispatch(appendTest(params)),
  showToast: (params) => dispatch(showToast(params))
});

export default connect(null, mapDispatchToProps)(DoTest);


